import React, { useState, useEffect, useRef } from 'react';

function CariRefer({ onSelect, onCancel, start_date }) {
  const [ruteList, setRuteList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredRute, setFilteredRute] = useState([]);
  const schema = localStorage.getItem('schema');
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();

    const fetchRute = async () => {
      try {
        const tanggal = start_date || new Date().toISOString().split('T')[0];
        const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=do_refer&schema=${schema}&start_date=${tanggal}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        const ruteArray = Array.isArray(data) ? data : [];
        setRuteList(ruteArray);
        setFilteredRute(ruteArray);
      } catch (error) {
        console.error('Error fetching DO Refer:', error);
      }
    };

    fetchRute();
  }, [start_date, schema]);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    const filtered = ruteList.filter(
      (rute) =>
        rute.NO_TRANSAKSI?.toLowerCase().includes(term) ||
        rute.KOTA_ASAL?.toLowerCase().includes(term) ||
        rute.KOTA_TUJUAN?.toLowerCase().includes(term)
    );
    setFilteredRute(filtered);
  }, [searchTerm, ruteList]);

  const isMobile = window.innerWidth <= 480;

  return (
    <div
      style={{
        width: isMobile ? '90%' : '500px',
        margin: isMobile ? '20px auto' : '40px auto',
        padding: isMobile ? '15px' : '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
        position: 'relative',
      }}
    >
      <button
        onClick={onCancel}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          backgroundColor: '#f44336',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          padding: isMobile ? '4px 8px' : '6px 12px',
          cursor: 'pointer',
          fontSize: isMobile ? '12px' : '14px',
        }}
      >
        ✖
      </button>

      <h2
        style={{
          textAlign: 'center',
          color: '#333',
          marginTop: isMobile ? '10px' : '0',
          marginBottom: '15px',
          fontSize: isMobile ? '16px' : '20px',
        }}
      >
        Cari DO Refer
      </h2>

      <div style={{ marginBottom: '15px' }}>
        <input
          ref={inputRef}
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Cari No DO / Kota"
          style={{
            width: '100%',
            padding: isMobile ? '6px' : '8px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            fontSize: isMobile ? '13px' : '14px',
          }}
        />
      </div>

      <div
        style={{
          maxHeight: isMobile ? '250px' : '320px',
          overflowY: 'auto',
          overflowX: 'hidden',
          borderRadius: '6px',
          border: '1px solid #eee',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: isMobile ? '12.5px' : '14px',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <th style={{ border: '1px solid #ddd', padding: '6px' }}>No. DO</th>
              <th style={{ border: '1px solid #ddd', padding: '6px' }}>Kota Asal</th>
              <th style={{ border: '1px solid #ddd', padding: '6px' }}>Kota Tujuan</th>
              <th style={{ border: '1px solid #ddd', padding: '6px', textAlign: 'center' }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {filteredRute.length > 0 ? (
              filteredRute.map((rute, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                    cursor: 'pointer',
                  }}
                  onDoubleClick={() => onSelect(rute)}
                >
                  <td style={{ border: '1px solid #ddd', padding: '6px' }}>
                    {rute.NO_TRANSAKSI}
                  </td>
                  <td style={{ border: '1px solid #ddd', padding: '6px' }}>
                    {rute.KOTA_ASAL}
                  </td>
                  <td style={{ border: '1px solid #ddd', padding: '6px' }}>
                    {rute.KOTA_TUJUAN}
                  </td>
                  <td
                    style={{
                      textAlign: 'center',
                      border: '1px solid #ddd',
                      padding: '6px',
                    }}
                  >
                    <button
                      onClick={() => onSelect(rute)}
                      style={{
                        padding: '5px 10px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: '13px',
                      }}
                    >
                      Pilih
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="4"
                  style={{
                    textAlign: 'center',
                    padding: '10px',
                    color: '#888',
                    fontSize: isMobile ? '13px' : '14px',
                  }}
                >
                  Tidak ada data DO.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CariRefer;
